import { Stack, Typography } from '@mui/material'
import { DensityStyleTypes, Organization } from '../../../types'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

interface ChildContractedByProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const ChildContractedByCell = ({ params, densityStyles }: ChildContractedByProps): React.ReactElement => {
  const childContractedByName =
    params?.row?.contractedByOrg?.length > 0
      ? params?.row?.contractedByOrg.map((org: Organization) => org.name).join(', ')
      : 'No Organizations'
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Stack
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'left',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography
        sx={{
          fontSize: densityStyles.fontSize,
          //   color: renderColorByString(params?.value),
          color: 'text.disabled',
          fontStyle: 'italic',
          textAlign: 'left',
        }}
      >
        {childContractedByName ?? '—'}
      </Typography>
    </Stack>
  )
}
export default ChildContractedByCell
// ="https://localhost:3000/deals/" & A15 & "/" & C15 & "/" & "agreement"
